export async function postContact(booking: Booking) {
    const apiUrl = window.react_data.api_url || 'http://localhost:8000/api/v1/';

    let data = new FormData();
    data.append('booking', JSON.stringify(booking));

    return fetch(apiUrl + 'contact', { body: data, method: 'post' }).catch(() => {});
}
